// Chaves de sessão do localStorage.
//
// Existe para que ninguém volte a usar `localStorage.clear()` para encerrar uma
// sessão: o clear apaga TAMBÉM as mensagens pendentes/otimistas e as preferências
// de tema, e como o localStorage é compartilhado entre abas do mesmo navegador,
// uma aba encerrando a sessão destruía o estado das outras.
// `sessionExpired` NÃO entra aqui de propósito: é o recado que a tela de login
// exibe ("sua sessão expirou"), gravado logo depois de limpar a sessão. Se fosse
// limpo junto, a própria limpeza apagaria o aviso antes de alguém o ler.
export const SESSION_KEYS = [
  "token",
  "companyId",
  "userId",
  "cshow",
  "companyDueDate",
  "crmOptimisticMessages",
  "crmPendingMessages"
];

export const clearSessionKeys = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

export default clearSessionKeys;
